import React, { useState } from "react";
import { Sparkle, CaretDown, CaretUp } from "@phosphor-icons/react";

/** Collapsible "Read the AI summary" toggle that sits under the intro audio.
 * No-ops when no `summary` is supplied (so empty cards don't show empty toggles). */
export default function IntroAudioSummary({ summary, testid }) {
  const [open, setOpen] = useState(false);
  if (!summary) return null;
  return (
    <div className="md-intro-summary-wrap" data-testid={`intro-summary-wrap-${testid}`}>
      <button
        type="button"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); }}
        className="md-intro-summary-toggle"
        aria-expanded={open}
        data-testid={`intro-summary-toggle-${testid}`}
      >
        <Sparkle size={11} weight="fill" />
        {open ? "Hide summary" : "Read the summary"}
        {open ? <CaretUp size={10} weight="bold" /> : <CaretDown size={10} weight="bold" />}
      </button>
      {open && (
        <p className="md-intro-summary-body" data-testid={`intro-summary-body-${testid}`}>
          {summary}
        </p>
      )}
    </div>
  );
}
